/**
 * WEST DEKLE: search modal welcome panel (snippets/predictive-search-empty-state.liquid).
 * Types example searches one after another and runs a search when a chip is clicked.
 */
class WdSearchWelcome extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    this.addEventListener('click', this.#onClick);

    const examples = (this.dataset.examples || '').split('|').filter(Boolean);
    const typed = this.querySelector('[data-wd-typed]');
    const button = typed?.closest('[data-wd-q]');
    if (!typed || !button || examples.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let index = 0;
    let length = examples[0].length;
    let phase = 'hold';
    let hold = 18; // ticks to show a finished example before deleting it

    const tick = () => {
      // Only animate while the panel is visible (modal open)
      if (this.offsetParent !== null) {
        if (phase === 'hold') {
          hold -= 1;
          if (hold <= 0) phase = 'delete';
        } else if (phase === 'delete') {
          length -= 1;
          if (length <= 0) {
            index = (index + 1) % examples.length;
            button.setAttribute('data-wd-q', examples[index]);
            phase = 'type';
          }
        } else {
          length += 1;
          if (length >= examples[index].length) {
            phase = 'hold';
            hold = 22;
          }
        }
        typed.textContent = examples[index].slice(0, length) || ' ';
      }
      this.#timer = window.setTimeout(tick, phase === 'delete' ? 35 : 75);
    };

    this.#timer = window.setTimeout(tick, 900);
  }

  disconnectedCallback() {
    window.clearTimeout(this.#timer);
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    const trigger = target.closest('[data-wd-q]');
    if (!(trigger instanceof HTMLElement)) return;

    const component = this.closest('predictive-search-component');
    const input = component?.querySelector('input[name="q"]');
    if (!(input instanceof HTMLInputElement)) return;

    event.preventDefault();
    input.value = trigger.dataset.wdQ || '';
    input.focus();
    input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: input.value }));
  };
}

if (!customElements.get('wd-search-welcome')) {
  customElements.define('wd-search-welcome', WdSearchWelcome);
}
